const dm = require('@progress/kendo-date-math');
dm.loadTimezone({
  "rules": {
    "GB-Eire": [
      [
        1916,
        "only",
        "-",
        "May",
        "21",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1916,
        "only",
        "-",
        "Oct",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1917,
        "only",
        "-",
        "Apr",
        "8",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1917,
        "only",
        "-",
        "Sep",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1918,
        "only",
        "-",
        "Mar",
        "24",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1918,
        "only",
        "-",
        "Sep",
        "30",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1919,
        "only",
        "-",
        "Mar",
        "30",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1919,
        "only",
        "-",
        "Sep",
        "29",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1920,
        "only",
        "-",
        "Mar",
        "28",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1920,
        "only",
        "-",
        "Oct",
        "25",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1921,
        "only",
        "-",
        "Apr",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "26",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1922,
        "only",
        "-",
        "Oct",
        "8",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1923,
        "only",
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1923,
        1924,
        "-",
        "Sep",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1924,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1925,
        1926,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1925,
        1938,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1928,
        1929,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1930,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1931,
        1932,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1933,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1934,
        "only",
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1935,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1936,
        1937,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1938,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1939,
        "only",
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1939,
        "only",
        "-",
        "Nov",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1940,
        "only",
        "-",
        "Feb",
        "Sun>=23",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1941,
        "only",
        "-",
        "May",
        "Sun>=2",
        [
          1,
          0,
          0,
          "s"
        ],
        120,
        "BDST"
      ],
      [
        1941,
        1943,
        "-",
        "Aug",
        "Sun>=9",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1942,
        1944,
        "-",
        "Apr",
        "Sun>=2",
        [
          1,
          0,
          0,
          "s"
        ],
        120,
        "BDST"
      ],
      [
        1944,
        "only",
        "-",
        "Sep",
        "Sun>=16",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "Mon>=2",
        [
          1,
          0,
          0,
          "s"
        ],
        120,
        "BDST"
      ],
      [
        1945,
        "only",
        "-",
        "Jul",
        "Sun>=9",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1945,
        1946,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1946,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1947,
        "only",
        "-",
        "Mar",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1947,
        "only",
        "-",
        "Apr",
        "13",
        [
          1,
          0,
          0,
          "s"
        ],
        120,
        "BDST"
      ],
      [
        1947,
        "only",
        "-",
        "Aug",
        "10",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1947,
        "only",
        "-",
        "Nov",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1948,
        "only",
        "-",
        "Mar",
        "14",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1948,
        "only",
        "-",
        "Oct",
        "31",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1949,
        "only",
        "-",
        "Oct",
        "30",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1950,
        1952,
        "-",
        "Apr",
        "Sun>=14",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1950,
        1952,
        "-",
        "Oct",
        "Sun>=21",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1953,
        "only",
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1953,
        1960,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1954,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1955,
        1956,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1957,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1958,
        1959,
        "-",
        "Apr",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1960,
        "only",
        "-",
        "Apr",
        "Sun>=9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1961,
        1963,
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1961,
        1968,
        "-",
        "Oct",
        "Sun>=23",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1964,
        1967,
        "-",
        "Mar",
        "Sun>=19",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1968,
        "only",
        "-",
        "Feb",
        "18",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1972,
        1980,
        "-",
        "Mar",
        "Sun>=16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "BST"
      ],
      [
        1972,
        1980,
        "-",
        "Oct",
        "Sun>=23",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "GMT"
      ],
      [
        1981,
        1995,
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        60,
        "BST"
      ],
      [
        1981,
        1989,
        "-",
        "Oct",
        "Sun>=23",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "GMT"
      ],
      [
        1990,
        1995,
        "-",
        "Oct",
        "Sun>=22",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "GMT"
      ]
    ],
    "EU": [
      [
        1977,
        1980,
        "-",
        "Apr",
        "Sun>=1",
        [
          1,
          0,
          0,
          "u"
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ],
      [
        1979,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ],
      [
        1981,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        60,
        "S"
      ],
      [
        1996,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ]
    ],
    "Eire": [
      [
        1971,
        "only",
        "-",
        "Oct",
        "31",
        [
          2,
          0,
          0,
          "u"
        ],
        -60,
        "-"
      ],
      [
        1972,
        1980,
        "-",
        "Mar",
        "Sun>=16",
        [
          2,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ],
      [
        1972,
        1980,
        "-",
        "Oct",
        "Sun>=23",
        [
          2,
          0,
          0,
          "u"
        ],
        -60,
        "-"
      ],
      [
        1981,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        0,
        "-"
      ],
      [
        1981,
        1989,
        "-",
        "Oct",
        "Sun>=23",
        [
          1,
          0,
          0,
          "u"
        ],
        -60,
        "-"
      ],
      [
        1990,
        1995,
        "-",
        "Oct",
        "Sun>=22",
        [
          1,
          0,
          0,
          "u"
        ],
        -60,
        "-"
      ],
      [
        1996,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          1,
          0,
          0,
          "u"
        ],
        -60,
        "-"
      ]
    ],
    "Albania": [
      [
        1940,
        "only",
        "-",
        "Jun",
        "16",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "2",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1943,
        "only",
        "-",
        "Mar",
        "29",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1943,
        "only",
        "-",
        "Apr",
        "10",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1974,
        "only",
        "-",
        "May",
        "4",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1974,
        "only",
        "-",
        "Oct",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1975,
        "only",
        "-",
        "May",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1975,
        "only",
        "-",
        "Oct",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "May",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1976,
        "only",
        "-",
        "Oct",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1977,
        "only",
        "-",
        "May",
        "8",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Oct",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "May",
        "6",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1979,
        "only",
        "-",
        "May",
        "5",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1979,
        "only",
        "-",
        "Sep",
        "30",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "May",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Oct",
        "4",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        "only",
        "-",
        "Apr",
        "26",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1981,
        "only",
        "-",
        "Sep",
        "27",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1982,
        "only",
        "-",
        "May",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1982,
        "only",
        "-",
        "Oct",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1983,
        "only",
        "-",
        "Apr",
        "18",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1983,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1984,
        "only",
        "-",
        "Apr",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ]
    ],
    "C-Eur": [
      [
        1916,
        "only",
        "-",
        "Apr",
        "30",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Oct",
        "1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1917,
        1918,
        "-",
        "Apr",
        "Mon>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1917,
        1918,
        "-",
        "Sep",
        "Mon>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Apr",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1943,
        "only",
        "-",
        "Mar",
        "29",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1943,
        "only",
        "-",
        "Oct",
        "4",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1944,
        1945,
        "-",
        "Apr",
        "Mon>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Oct",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1977,
        1980,
        "-",
        "Apr",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1979,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1981,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1996,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Austria": [
      [
        1920,
        "only",
        "-",
        "Apr",
        "5",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Sep",
        "13",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "Apr",
        "14",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        1948,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        "only",
        "-",
        "Apr",
        "6",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1948,
        "only",
        "-",
        "Apr",
        "18",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Apr",
        "6",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Sep",
        "28",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "Russia": [
      [
        1917,
        "only",
        "-",
        "Jul",
        "1",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "MST",
        ""
      ],
      [
        1917,
        "only",
        "-",
        "Dec",
        "28",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "MMT",
        ""
      ],
      [
        1918,
        "only",
        "-",
        "May",
        "31",
        [
          22,
          0,
          0,
          null
        ],
        120,
        "MDST",
        ""
      ],
      [
        1918,
        "only",
        "-",
        "Sep",
        "16",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "MST"
      ],
      [
        1919,
        "only",
        "-",
        "May",
        "31",
        [
          23,
          0,
          0,
          null
        ],
        120,
        "MDST"
      ],
      [
        1919,
        "only",
        "-",
        "Jul",
        "1",
        [
          0,
          0,
          0,
          "u"
        ],
        60,
        "MSD"
      ],
      [
        1919,
        "only",
        "-",
        "Aug",
        "16",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "MSK"
      ],
      [
        1921,
        "only",
        "-",
        "Feb",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "MSD"
      ],
      [
        1921,
        "only",
        "-",
        "Mar",
        "20",
        [
          23,
          0,
          0,
          null
        ],
        120,
        "+05"
      ],
      [
        1921,
        "only",
        "-",
        "Sep",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "MSD"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        1984,
        "-",
        "Apr",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1981,
        1983,
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1984,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1985,
        2010,
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1996,
        2010,
        "-",
        "Oct",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Belgium": [
      [
        1918,
        "only",
        "-",
        "Mar",
        "9",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1918,
        1919,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Mar",
        "1",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Feb",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Oct",
        "23",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1921,
        "only",
        "-",
        "Mar",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "25",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "25",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1922,
        1927,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1923,
        "only",
        "-",
        "Apr",
        "21",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Mar",
        "29",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1925,
        "only",
        "-",
        "Apr",
        "4",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1926,
        "only",
        "-",
        "Apr",
        "17",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "9",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1928,
        "only",
        "-",
        "Apr",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1928,
        1938,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1929,
        "only",
        "-",
        "Apr",
        "21",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1930,
        "only",
        "-",
        "Apr",
        "13",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1931,
        "only",
        "-",
        "Apr",
        "19",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1932,
        "only",
        "-",
        "Apr",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1933,
        "only",
        "-",
        "Mar",
        "26",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1934,
        "only",
        "-",
        "Apr",
        "8",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1935,
        "only",
        "-",
        "Mar",
        "31",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1936,
        "only",
        "-",
        "Apr",
        "19",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1937,
        "only",
        "-",
        "Apr",
        "4",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1938,
        "only",
        "-",
        "Mar",
        "27",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Apr",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Nov",
        "19",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Feb",
        "25",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Sep",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "May",
        "19",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "7",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Bulg": [
      [
        1979,
        "only",
        "-",
        "Mar",
        "31",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1979,
        "only",
        "-",
        "Oct",
        "1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        1982,
        "-",
        "Apr",
        "Sat>=1",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Sep",
        "29",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        "only",
        "-",
        "Sep",
        "27",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "E-Eur": [
      [
        1977,
        1980,
        "-",
        "Apr",
        "Sun>=1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1979,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1996,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "Czech": [
      [
        1945,
        "only",
        "-",
        "Apr",
        "Mon>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Oct",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "May",
        "6",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        1949,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        1948,
        "-",
        "Apr",
        "Sun>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ]
    ],
    "Denmark": [
      [
        1916,
        "only",
        "-",
        "May",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Sep",
        "30",
        [
          23,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "May",
        "15",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Aug",
        "15",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "May",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Sep",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        "only",
        "-",
        "May",
        "4",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1947,
        "only",
        "-",
        "Aug",
        "10",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1948,
        "only",
        "-",
        "May",
        "9",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1948,
        "only",
        "-",
        "Aug",
        "8",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Finland": [
      [
        1942,
        "only",
        "-",
        "Apr",
        "2",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Oct",
        "4",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        1982,
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1981,
        1982,
        "-",
        "Sep",
        "lastSun",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "France": [
      [
        1916,
        "only",
        "-",
        "Jun",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1916,
        1919,
        "-",
        "Oct",
        "Sun>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1917,
        "only",
        "-",
        "Mar",
        "24",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1918,
        "only",
        "-",
        "Mar",
        "9",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1919,
        "only",
        "-",
        "Mar",
        "1",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Feb",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Oct",
        "23",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1921,
        "only",
        "-",
        "Mar",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "25",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "25",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1922,
        1938,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1923,
        "only",
        "-",
        "May",
        "26",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Mar",
        "29",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1925,
        "only",
        "-",
        "Apr",
        "4",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1926,
        "only",
        "-",
        "Apr",
        "17",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "9",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1928,
        "only",
        "-",
        "Apr",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1929,
        "only",
        "-",
        "Apr",
        "20",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1930,
        "only",
        "-",
        "Apr",
        "12",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1931,
        "only",
        "-",
        "Apr",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1932,
        "only",
        "-",
        "Apr",
        "2",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1933,
        "only",
        "-",
        "Mar",
        "25",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1934,
        "only",
        "-",
        "Apr",
        "7",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1935,
        "only",
        "-",
        "Mar",
        "30",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1936,
        "only",
        "-",
        "Apr",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1937,
        "only",
        "-",
        "Apr",
        "3",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1938,
        "only",
        "-",
        "Mar",
        "26",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Apr",
        "15",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Nov",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Feb",
        "25",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1941,
        "only",
        "-",
        "May",
        "5",
        [
          0,
          0,
          0,
          null
        ],
        120,
        "M",
        ""
      ],
      [
        1941,
        "only",
        "-",
        "Oct",
        "6",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Mar",
        "9",
        [
          0,
          0,
          0,
          null
        ],
        120,
        "M"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "2",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1943,
        "only",
        "-",
        "Mar",
        "29",
        [
          2,
          0,
          0,
          null
        ],
        120,
        "M"
      ],
      [
        1943,
        "only",
        "-",
        "Oct",
        "4",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Apr",
        "3",
        [
          2,
          0,
          0,
          null
        ],
        120,
        "M"
      ],
      [
        1944,
        "only",
        "-",
        "Oct",
        "8",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          null
        ],
        120,
        "M"
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "16",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "Mar",
        "28",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1976,
        "only",
        "-",
        "Sep",
        "26",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "SovietZone": [
      [
        1945,
        "only",
        "-",
        "May",
        "24",
        [
          2,
          0,
          0,
          null
        ],
        120,
        "M",
        ""
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "24",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Nov",
        "18",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Germany": [
      [
        1946,
        "only",
        "-",
        "Apr",
        "14",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "7",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        1949,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        "only",
        "-",
        "Apr",
        "6",
        [
          3,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1947,
        "only",
        "-",
        "May",
        "11",
        [
          2,
          0,
          0,
          "s"
        ],
        120,
        "M"
      ],
      [
        1947,
        "only",
        "-",
        "Jun",
        "29",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1948,
        "only",
        "-",
        "Apr",
        "18",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "10",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ]
    ],
    "Greece": [
      [
        1932,
        "only",
        "-",
        "Jul",
        "7",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1932,
        "only",
        "-",
        "Sep",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1941,
        "only",
        "-",
        "Apr",
        "7",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "2",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1943,
        "only",
        "-",
        "Mar",
        "30",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1943,
        "only",
        "-",
        "Oct",
        "4",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1952,
        "only",
        "-",
        "Jul",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1952,
        "only",
        "-",
        "Nov",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1975,
        "only",
        "-",
        "Apr",
        "12",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1975,
        "only",
        "-",
        "Nov",
        "26",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "Apr",
        "11",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1976,
        "only",
        "-",
        "Oct",
        "10",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1977,
        1978,
        "-",
        "Apr",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "26",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "Sep",
        "24",
        [
          4,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1979,
        "only",
        "-",
        "Apr",
        "1",
        [
          9,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1979,
        "only",
        "-",
        "Sep",
        "29",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "Apr",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Sep",
        "28",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "Hungary": [
      [
        1918,
        "only",
        "-",
        "Apr",
        "1",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1918,
        "only",
        "-",
        "Sep",
        "16",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Apr",
        "15",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1919,
        "only",
        "-",
        "Nov",
        "24",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "May",
        "1",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Nov",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "Mar",
        "31",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        1949,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        1949,
        "-",
        "Apr",
        "Sun>=4",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1950,
        "only",
        "-",
        "Apr",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1950,
        "only",
        "-",
        "Oct",
        "23",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1954,
        1955,
        "-",
        "May",
        "23",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1954,
        1955,
        "-",
        "Oct",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1956,
        "only",
        "-",
        "Jun",
        "Sun>=1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1956,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1957,
        "only",
        "-",
        "Jun",
        "Sun>=1",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1957,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "Apr",
        "6",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ]
    ],
    "Italy": [
      [
        1916,
        "only",
        "-",
        "Jun",
        "3",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        1917,
        "-",
        "Sep",
        "30",
        [
          24,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1917,
        "only",
        "-",
        "Mar",
        "31",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1918,
        "only",
        "-",
        "Mar",
        "9",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1918,
        "only",
        "-",
        "Oct",
        "6",
        [
          24,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Mar",
        "1",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1919,
        "only",
        "-",
        "Oct",
        "4",
        [
          24,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1920,
        "only",
        "-",
        "Mar",
        "20",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Sep",
        "18",
        [
          24,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Jun",
        "14",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1943,
        "only",
        "-",
        "Mar",
        "29",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1943,
        "only",
        "-",
        "Oct",
        "4",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1944,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Sep",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "15",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "Mar",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "6",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        "only",
        "-",
        "Mar",
        "16",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1947,
        "only",
        "-",
        "Oct",
        "5",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1948,
        "only",
        "-",
        "Feb",
        "29",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1948,
        "only",
        "-",
        "Oct",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1966,
        1968,
        "-",
        "May",
        "Sun>=22",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1966,
        "only",
        "-",
        "Sep",
        "24",
        [
          24,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1967,
        1969,
        "-",
        "Sep",
        "Sun>=22",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1969,
        "only",
        "-",
        "Jun",
        "1",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1970,
        "only",
        "-",
        "May",
        "31",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1970,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1971,
        1972,
        "-",
        "May",
        "Sun>=22",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1971,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1972,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1973,
        "only",
        "-",
        "Jun",
        "3",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1973,
        1974,
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1974,
        "only",
        "-",
        "May",
        "26",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1975,
        "only",
        "-",
        "Jun",
        "1",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1975,
        1977,
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "May",
        "30",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1977,
        1979,
        "-",
        "May",
        "Sun>=22",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1979,
        "only",
        "-",
        "Sep",
        "30",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Latvia": [
      [
        1989,
        1996,
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1989,
        1996,
        "-",
        "Sep",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Lux": [
      [
        1916,
        "only",
        "-",
        "May",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Oct",
        "1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1917,
        "only",
        "-",
        "Apr",
        "28",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1917,
        "only",
        "-",
        "Sep",
        "17",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1918,
        "only",
        "-",
        "Apr",
        "Mon>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1918,
        "only",
        "-",
        "Sep",
        "Mon>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Mar",
        "1",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1919,
        "only",
        "-",
        "Oct",
        "5",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1920,
        "only",
        "-",
        "Feb",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Oct",
        "24",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1921,
        "only",
        "-",
        "Mar",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "26",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "25",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1922,
        "only",
        "-",
        "Oct",
        "Sun>=2",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1923,
        "only",
        "-",
        "Apr",
        "21",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1923,
        "only",
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1924,
        "only",
        "-",
        "Mar",
        "29",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1924,
        1928,
        "-",
        "Oct",
        "Sun>=2",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1925,
        "only",
        "-",
        "Apr",
        "5",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1926,
        "only",
        "-",
        "Apr",
        "17",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "9",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1928,
        "only",
        "-",
        "Apr",
        "14",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1929,
        "only",
        "-",
        "Apr",
        "20",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ]
    ],
    "Malta": [
      [
        1973,
        "only",
        "-",
        "Mar",
        "31",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1973,
        "only",
        "-",
        "Sep",
        "29",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1974,
        "only",
        "-",
        "Apr",
        "21",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1974,
        "only",
        "-",
        "Sep",
        "16",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1975,
        1979,
        "-",
        "Apr",
        "Sun>=15",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1975,
        1980,
        "-",
        "Sep",
        "Sun>=15",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "Mar",
        "31",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ]
    ],
    "Romania": [
      [
        1932,
        "only",
        "-",
        "May",
        "21",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1932,
        1939,
        "-",
        "Oct",
        "Sun>=1",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1933,
        1939,
        "-",
        "Apr",
        "Sun>=2",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1979,
        "only",
        "-",
        "May",
        "27",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1979,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "Apr",
        "5",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1980,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1991,
        1993,
        "-",
        "Mar",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1991,
        1993,
        "-",
        "Sep",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Moldova": [
      [
        1997,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1997,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "Neth": [
      [
        1916,
        "only",
        "-",
        "May",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "NST",
        ""
      ],
      [
        1916,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "AMT",
        ""
      ],
      [
        1917,
        "only",
        "-",
        "Apr",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1917,
        "only",
        "-",
        "Sep",
        "17",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "AMT"
      ],
      [
        1918,
        1921,
        "-",
        "Apr",
        "Mon>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1918,
        1921,
        "-",
        "Sep",
        "lastMon",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "AMT"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1922,
        1936,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "AMT"
      ],
      [
        1923,
        "only",
        "-",
        "Jun",
        "Fri>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1924,
        "only",
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1925,
        "only",
        "-",
        "Jun",
        "Fri>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1926,
        1931,
        "-",
        "May",
        "15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1932,
        "only",
        "-",
        "May",
        "22",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1933,
        1936,
        "-",
        "May",
        "15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1937,
        "only",
        "-",
        "May",
        "22",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "NST"
      ],
      [
        1937,
        "only",
        "-",
        "Jul",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1937,
        1939,
        "-",
        "Oct",
        "Sun>=2",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1938,
        1939,
        "-",
        "May",
        "15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Sep",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Norway": [
      [
        1916,
        "only",
        "-",
        "May",
        "22",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Sep",
        "30",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Oct",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1959,
        1964,
        "-",
        "Mar",
        "Sun>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1959,
        1965,
        "-",
        "Sep",
        "Sun>=15",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1965,
        "only",
        "-",
        "Apr",
        "25",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ]
    ],
    "Poland": [
      [
        1918,
        1919,
        "-",
        "Sep",
        "16",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Apr",
        "15",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Apr",
        "3",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        "only",
        "-",
        "Oct",
        "4",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "29",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Nov",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "Apr",
        "14",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "7",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        "only",
        "-",
        "May",
        "4",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1947,
        1949,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1948,
        "only",
        "-",
        "Apr",
        "18",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "10",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1957,
        "only",
        "-",
        "Jun",
        "2",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1957,
        1958,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1958,
        "only",
        "-",
        "Mar",
        "30",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1959,
        "only",
        "-",
        "May",
        "31",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1959,
        1961,
        "-",
        "Oct",
        "Sun>=1",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1960,
        "only",
        "-",
        "Apr",
        "3",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1961,
        1964,
        "-",
        "May",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1962,
        1964,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "W-Eur": [
      [
        1977,
        1980,
        "-",
        "Apr",
        "Sun>=1",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1979,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1981,
        "max",
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1996,
        "max",
        "-",
        "Oct",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Port": [
      [
        1916,
        "only",
        "-",
        "Jun",
        "17",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Nov",
        "1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1917,
        "only",
        "-",
        "Feb",
        "28",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1917,
        1921,
        "-",
        "Oct",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1918,
        "only",
        "-",
        "Mar",
        "1",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1919,
        "only",
        "-",
        "Feb",
        "28",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Feb",
        "29",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1921,
        "only",
        "-",
        "Feb",
        "28",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Apr",
        "16",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Oct",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1926,
        "only",
        "-",
        "Apr",
        "17",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1926,
        1929,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "9",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1928,
        "only",
        "-",
        "Apr",
        "14",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1929,
        "only",
        "-",
        "Apr",
        "20",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1931,
        "only",
        "-",
        "Apr",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1931,
        1932,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1932,
        "only",
        "-",
        "Apr",
        "2",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1934,
        "only",
        "-",
        "Apr",
        "7",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1934,
        1938,
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1935,
        "only",
        "-",
        "Mar",
        "30",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1936,
        "only",
        "-",
        "Apr",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1937,
        "only",
        "-",
        "Apr",
        "3",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1938,
        "only",
        "-",
        "Mar",
        "26",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Apr",
        "15",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Nov",
        "18",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Feb",
        "24",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1940,
        1941,
        "-",
        "Oct",
        "5",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1941,
        "only",
        "-",
        "Apr",
        "5",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1942,
        1945,
        "-",
        "Mar",
        "Sat>=8",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Apr",
        "25",
        [
          22,
          0,
          0,
          "s"
        ],
        120,
        "M",
        ""
      ],
      [
        1942,
        "only",
        "-",
        "Aug",
        "15",
        [
          22,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1942,
        1945,
        "-",
        "Oct",
        "Sat>=24",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1943,
        "only",
        "-",
        "Apr",
        "17",
        [
          22,
          0,
          0,
          "s"
        ],
        120,
        "M"
      ],
      [
        1943,
        1945,
        "-",
        "Aug",
        "Sat>=25",
        [
          22,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1944,
        1945,
        "-",
        "Apr",
        "Sat>=21",
        [
          22,
          0,
          0,
          "s"
        ],
        120,
        "M"
      ],
      [
        1946,
        "only",
        "-",
        "Apr",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "Sat>=1",
        [
          23,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1947,
        1949,
        "-",
        "Apr",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1947,
        1949,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1951,
        1965,
        "-",
        "Apr",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1951,
        1965,
        "-",
        "Oct",
        "Sun>=1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1977,
        "only",
        "-",
        "Mar",
        "27",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Sep",
        "25",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1978,
        1979,
        "-",
        "Apr",
        "Sun>=1",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1979,
        1982,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1980,
        "only",
        "-",
        "Mar",
        "lastSun",
        [
          0,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1981,
        1982,
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1983,
        "only",
        "-",
        "Mar",
        "lastSun",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ]
    ],
    "Spain": [
      [
        1918,
        "only",
        "-",
        "Apr",
        "15",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1918,
        1919,
        "-",
        "Oct",
        "6",
        [
          24,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1919,
        "only",
        "-",
        "Apr",
        "6",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Apr",
        "16",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1924,
        "only",
        "-",
        "Oct",
        "4",
        [
          24,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1926,
        "only",
        "-",
        "Apr",
        "17",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1926,
        1929,
        "-",
        "Oct",
        "Sat>=1",
        [
          24,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1927,
        "only",
        "-",
        "Apr",
        "9",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1928,
        "only",
        "-",
        "Apr",
        "15",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1929,
        "only",
        "-",
        "Apr",
        "20",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1937,
        "only",
        "-",
        "Jun",
        "16",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1937,
        "only",
        "-",
        "Oct",
        "2",
        [
          24,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1938,
        "only",
        "-",
        "Apr",
        "2",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1938,
        "only",
        "-",
        "Apr",
        "30",
        [
          23,
          0,
          0,
          null
        ],
        120,
        "M"
      ],
      [
        1938,
        "only",
        "-",
        "Oct",
        "2",
        [
          24,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1939,
        "only",
        "-",
        "Oct",
        "7",
        [
          24,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1942,
        "only",
        "-",
        "May",
        "2",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Sep",
        "1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1943,
        1946,
        "-",
        "Apr",
        "Sat>=13",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1943,
        1944,
        "-",
        "Oct",
        "Sun>=1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1945,
        1946,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "30",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1949,
        "only",
        "-",
        "Oct",
        "2",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1974,
        1975,
        "-",
        "Apr",
        "Sat>=12",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1974,
        1975,
        "-",
        "Oct",
        "Sun>=1",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "Mar",
        "27",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1976,
        1977,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1977,
        "only",
        "-",
        "Apr",
        "2",
        [
          23,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1978,
        "only",
        "-",
        "Apr",
        "2",
        [
          2,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1978,
        "only",
        "-",
        "Oct",
        "1",
        [
          2,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ],
    "Swiss": [
      [
        1941,
        1942,
        "-",
        "May",
        "Mon>=1",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1941,
        1942,
        "-",
        "Oct",
        "Mon>=1",
        [
          2,
          0,
          0,
          null
        ],
        0,
        "-"
      ]
    ],
    "Turkey": [
      [
        1916,
        "only",
        "-",
        "May",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1916,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1920,
        "only",
        "-",
        "Mar",
        "28",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1920,
        "only",
        "-",
        "Oct",
        "25",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1921,
        "only",
        "-",
        "Apr",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1921,
        "only",
        "-",
        "Oct",
        "3",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1922,
        "only",
        "-",
        "Mar",
        "26",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1922,
        "only",
        "-",
        "Oct",
        "8",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1924,
        "only",
        "-",
        "May",
        "13",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1924,
        1925,
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1925,
        "only",
        "-",
        "May",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1940,
        "only",
        "-",
        "Jun",
        "30",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1940,
        "only",
        "-",
        "Oct",
        "5",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1940,
        "only",
        "-",
        "Dec",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1941,
        "only",
        "-",
        "Sep",
        "21",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1942,
        "only",
        "-",
        "Apr",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1942,
        "only",
        "-",
        "Nov",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1945,
        "only",
        "-",
        "Apr",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1945,
        "only",
        "-",
        "Oct",
        "8",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1946,
        "only",
        "-",
        "Jun",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1946,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1947,
        1948,
        "-",
        "Apr",
        "Sun>=16",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1947,
        1950,
        "-",
        "Oct",
        "Sun>=2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1949,
        "only",
        "-",
        "Apr",
        "10",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1950,
        "only",
        "-",
        "Apr",
        "19",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1951,
        "only",
        "-",
        "Apr",
        "22",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1951,
        "only",
        "-",
        "Oct",
        "8",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1962,
        "only",
        "-",
        "Jul",
        "15",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1962,
        "only",
        "-",
        "Oct",
        "8",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1964,
        "only",
        "-",
        "May",
        "15",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1964,
        "only",
        "-",
        "Oct",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1970,
        1972,
        "-",
        "May",
        "Sun>=2",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1970,
        1972,
        "-",
        "Oct",
        "Sun>=2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1973,
        "only",
        "-",
        "Jun",
        "3",
        [
          1,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1973,
        "only",
        "-",
        "Nov",
        "4",
        [
          3,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1974,
        "only",
        "-",
        "Mar",
        "31",
        [
          2,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1974,
        "only",
        "-",
        "Nov",
        "3",
        [
          5,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1975,
        "only",
        "-",
        "Mar",
        "30",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1975,
        1976,
        "-",
        "Oct",
        "lastSun",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1976,
        "only",
        "-",
        "Jun",
        "1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1977,
        1978,
        "-",
        "Apr",
        "Sun>=1",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1977,
        "only",
        "-",
        "Oct",
        "16",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1979,
        1980,
        "-",
        "Apr",
        "Sun>=1",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1979,
        1982,
        "-",
        "Oct",
        "Mon>=11",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1981,
        1982,
        "-",
        "Mar",
        "lastSun",
        [
          3,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1983,
        "only",
        "-",
        "Jul",
        "31",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1983,
        "only",
        "-",
        "Oct",
        "2",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1985,
        "only",
        "-",
        "Apr",
        "20",
        [
          0,
          0,
          0,
          null
        ],
        60,
        "S"
      ],
      [
        1985,
        "only",
        "-",
        "Sep",
        "28",
        [
          0,
          0,
          0,
          null
        ],
        0,
        "-"
      ],
      [
        1986,
        1993,
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1986,
        1995,
        "-",
        "Sep",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ],
      [
        1994,
        "only",
        "-",
        "Mar",
        "20",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1995,
        2006,
        "-",
        "Mar",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        60,
        "S"
      ],
      [
        1996,
        2006,
        "-",
        "Oct",
        "lastSun",
        [
          1,
          0,
          0,
          "s"
        ],
        0,
        "-"
      ]
    ]
  },
  "titles": {
    "Europe/Nicosia": {
      "Europe/Nicosia": {
        "long": null,
        "group": null
      }
    },
    "Europe/Belfast": {
      "Europe/Belfast": {
        "long": null,
        "group": null
      }
    },
    "Europe/Tiraspol": {
      "Europe/Tiraspol": {
        "long": null,
        "group": null
      }
    },
    "Europe/London": {
      "Europe/London": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Jersey": {
      "Europe/Jersey": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Guernsey": {
      "Europe/Guernsey": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Isle_of_Man": {
      "Europe/Isle_of_Man": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Dublin": {
      "Europe/Dublin": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Tirane": {
      "Europe/Tirane": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Andorra": {
      "Europe/Andorra": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Vienna": {
      "Europe/Vienna": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Minsk": {
      "Europe/Minsk": {
        "long": "Kaliningrad Standard Time",
        "group": null
      }
    },
    "Europe/Brussels": {
      "Europe/Brussels": {
        "long": "Romance Standard Time",
        "group": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
      }
    },
    "Europe/Sofia": {
      "Europe/Sofia": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Prague": {
      "Europe/Prague": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Copenhagen": {
      "Europe/Copenhagen": {
        "long": "Romance Standard Time",
        "group": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
      }
    },
    "Europe/Tallinn": {
      "Europe/Tallinn": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Helsinki": {
      "Europe/Helsinki": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Mariehamn": {
      "Europe/Mariehamn": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Paris": {
      "Europe/Paris": {
        "long": "Romance Standard Time",
        "group": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
      }
    },
    "Europe/Berlin": {
      "Europe/Berlin": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Busingen": {
      "Europe/Busingen": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Gibraltar": {
      "Europe/Gibraltar": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Athens": {
      "Europe/Athens": {
        "long": "GTB Standard Time",
        "group": "(GMT+02:00) Athens, Bucharest, Istanbul"
      }
    },
    "Europe/Budapest": {
      "Europe/Budapest": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Rome": {
      "Europe/Rome": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Vatican": {
      "Europe/Vatican": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/San_Marino": {
      "Europe/San_Marino": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Riga": {
      "Europe/Riga": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Vaduz": {
      "Europe/Vaduz": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Vilnius": {
      "Europe/Vilnius": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Luxembourg": {
      "Europe/Luxembourg": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Malta": {
      "Europe/Malta": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Chisinau": {
      "Europe/Chisinau": {
        "long": "GTB Standard Time",
        "group": "(GMT+02:00) Athens, Bucharest, Istanbul"
      }
    },
    "Europe/Monaco": {
      "Europe/Monaco": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Amsterdam": {
      "Europe/Amsterdam": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Oslo": {
      "Europe/Oslo": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Warsaw": {
      "Europe/Warsaw": {
        "long": "Central European Standard Time",
        "group": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
      }
    },
    "Europe/Lisbon": {
      "Europe/Lisbon": {
        "long": "GMT Standard Time",
        "group": "(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London"
      }
    },
    "Europe/Bucharest": {
      "Europe/Bucharest": {
        "long": "GTB Standard Time",
        "group": "(GMT+02:00) Athens, Bucharest, Istanbul"
      }
    },
    "Europe/Kaliningrad": {
      "Europe/Kaliningrad": {
        "long": "Kaliningrad Standard Time",
        "group": null
      }
    },
    "Europe/Moscow": {
      "Europe/Moscow": {
        "long": "Russian Standard Time",
        "group": "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
      }
    },
    "Europe/Simferopol": {
      "Europe/Simferopol": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Astrakhan": {
      "Europe/Astrakhan": {
        "long": null,
        "group": null
      }
    },
    "Europe/Volgograd": {
      "Europe/Volgograd": {
        "long": "Russian Standard Time",
        "group": "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
      }
    },
    "Europe/Saratov": {
      "Europe/Saratov": {
        "long": null,
        "group": null
      }
    },
    "Europe/Kirov": {
      "Europe/Kirov": {
        "long": null,
        "group": null
      }
    },
    "Europe/Samara": {
      "Europe/Samara": {
        "long": "Russian Standard Time",
        "group": "(GMT+03:00) Moscow, St. Petersburg, Volgograd"
      }
    },
    "Europe/Ulyanovsk": {
      "Europe/Ulyanovsk": {
        "long": null,
        "group": null
      }
    },
    "Europe/Belgrade": {
      "Europe/Belgrade": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Ljubljana": {
      "Europe/Ljubljana": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Podgorica": {
      "Europe/Podgorica": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Sarajevo": {
      "Europe/Sarajevo": {
        "long": "Central European Standard Time",
        "group": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
      }
    },
    "Europe/Skopje": {
      "Europe/Skopje": {
        "long": "Central European Standard Time",
        "group": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
      }
    },
    "Europe/Zagreb": {
      "Europe/Zagreb": {
        "long": "Central European Standard Time",
        "group": "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb"
      }
    },
    "Europe/Bratislava": {
      "Europe/Bratislava": {
        "long": "Central Europe Standard Time",
        "group": "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague"
      }
    },
    "Europe/Madrid": {
      "Europe/Madrid": {
        "long": "Romance Standard Time",
        "group": "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris"
      }
    },
    "Europe/Stockholm": {
      "Europe/Stockholm": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Zurich": {
      "Europe/Zurich": {
        "long": "W. Europe Standard Time",
        "group": "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna"
      }
    },
    "Europe/Istanbul": {
      "Europe/Istanbul": {
        "long": "Turkey Standard Time",
        "group": null
      }
    },
    "Europe/Kiev": {
      "Europe/Kiev": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Uzhgorod": {
      "Europe/Uzhgorod": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    },
    "Europe/Zaporozhye": {
      "Europe/Zaporozhye": {
        "long": "FLE Standard Time",
        "group": "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius"
      }
    }
  },
  "zones": {
    "Europe/Nicosia": "Asia/Nicosia",
    "Europe/Belfast": "Europe/London",
    "Europe/Tiraspol": "Europe/Chisinau",
    "Europe/London": [
      [
        1.25,
        "-",
        "LMT",
        -3852662400000
      ],
      [
        0,
        "GB-Eire",
        "%s",
        -37238400000
      ],
      [
        -60,
        "-",
        "BST",
        57722400000
      ],
      [
        0,
        "GB-Eire",
        "%s",
        851990400000
      ],
      [
        0,
        "EU",
        "GMT/BST",
        null
      ]
    ],
    "Europe/Jersey": "Europe/London",
    "Europe/Guernsey": "Europe/London",
    "Europe/Isle_of_Man": "Europe/London",
    "Europe/Dublin": [
      [
        25,
        "-",
        "LMT",
        -2821651200000
      ],
      [
        25.35,
        "-",
        "DMT",
        -1691964000000
      ],
      [
        25.35,
        "1:00",
        "IST",
        -1680472800000
      ],
      [
        0,
        "GB-Eire",
        "%s",
        -1517011200000
      ],
      [
        0,
        "GB-Eire",
        "GMT/IST",
        -942012000000
      ],
      [
        0,
        "1:00",
        "IST",
        -733356000000
      ],
      [
        0,
        "-",
        "GMT",
        -719445600000
      ],
      [
        0,
        "1:00",
        "IST",
        -699487200000
      ],
      [
        0,
        "-",
        "GMT",
        -684972000000
      ],
      [
        0,
        "GB-Eire",
        "GMT/IST",
        -37238400000
      ],
      [
        -60,
        "Eire",
        "IST/GMT",
        null
      ]
    ],
    "Europe/Tirane": [
      [
        -79.33333333333333,
        "-",
        "LMT",
        -1735776000000
      ],
      [
        -60,
        "-",
        "CET",
        -932342400000
      ],
      [
        -60,
        "Albania",
        "CE%sT",
        457488000000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Andorra": [
      [
        -6.066666666666667,
        "-",
        "LMT",
        -2146003200000
      ],
      [
        0,
        "-",
        "WET",
        -733881600000
      ],
      [
        -60,
        "-",
        "CET",
        481082400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Vienna": [
      [
        -65.35,
        "-",
        "LMT",
        -2422051200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -1546387200000
      ],
      [
        -60,
        "Austria",
        "CE%sT",
        -938901600000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -781048800000
      ],
      [
        -60,
        "1:00",
        "CEST",
        -780184800000
      ],
      [
        -60,
        "-",
        "CET",
        -725932800000
      ],
      [
        -60,
        "Austria",
        "CE%sT",
        378604800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Minsk": [
      [
        -110.26666666666667,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -110,
        "-",
        "MMT",
        -1441152000000
      ],
      [
        -120,
        "-",
        "EET",
        -1247529600000
      ],
      [
        -180,
        "-",
        "MSK",
        -899769600000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -804643200000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        662601600000
      ],
      [
        -180,
        "-",
        "MSK",
        670384800000
      ],
      [
        -120,
        "Russia",
        "EE%sT",
        1301191200000
      ],
      [
        -180,
        "-",
        "+03",
        null
      ]
    ],
    "Europe/Brussels": [
      [
        -17.5,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -17.5,
        "-",
        "BMT",
        -2450952000000
      ],
      [
        0,
        "-",
        "WET",
        -1740355200000
      ],
      [
        -60,
        "-",
        "CET",
        -1693699200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -1613826000000
      ],
      [
        0,
        "Belgium",
        "WE%sT",
        -934668000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -799286400000
      ],
      [
        -60,
        "Belgium",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Sofia": [
      [
        -93.26666666666667,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -116.93333333333332,
        "-",
        "IMT",
        -2369520000000
      ],
      [
        -120,
        "-",
        "EET",
        -857250000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -757468800000
      ],
      [
        -60,
        "-",
        "CET",
        -781045200000
      ],
      [
        -120,
        "-",
        "EET",
        291769200000
      ],
      [
        -120,
        "Bulg",
        "EE%sT",
        401857200000
      ],
      [
        -120,
        "C-Eur",
        "EE%sT",
        694137600000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        883526400000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Prague": [
      [
        -57.733333333333334,
        "-",
        "LMT",
        -3755376000000
      ],
      [
        -57.733333333333334,
        "-",
        "PMT",
        -2469398400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -777859200000
      ],
      [
        -60,
        "Czech",
        "CE%sT",
        -728514000000
      ],
      [
        -60,
        "-1:00",
        "GMT",
        -721260000000
      ],
      [
        -60,
        "Czech",
        "CE%sT",
        315446400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Copenhagen": [
      [
        -50.333333333333336,
        "-",
        "LMT",
        -2493072000000
      ],
      [
        -50.333333333333336,
        "-",
        "CMT",
        -2398291200000
      ],
      [
        -60,
        "Denmark",
        "CE%sT",
        -857253600000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -781048800000
      ],
      [
        -60,
        "Denmark",
        "CE%sT",
        347068800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Tallinn": [
      [
        -99,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -99,
        "-",
        "TMT",
        -1638316800000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -1593820800000
      ],
      [
        -99,
        "-",
        "TMT",
        -1535932800000
      ],
      [
        -120,
        "-",
        "EET",
        -927936000000
      ],
      [
        -180,
        "-",
        "MSK",
        -892944000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -797644800000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        606880800000
      ],
      [
        -120,
        "1:00",
        "EEST",
        622605600000
      ],
      [
        -120,
        "C-Eur",
        "EE%sT",
        906422400000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        941342400000
      ],
      [
        -120,
        "-",
        "EET",
        1014249600000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Helsinki": [
      [
        -99.81666666666668,
        "-",
        "LMT",
        -2890252800000
      ],
      [
        -99.81666666666668,
        "-",
        "HMT",
        -1535932800000
      ],
      [
        -120,
        "Finland",
        "EE%sT",
        441676800000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Mariehamn": "Europe/Helsinki",
    "Europe/Paris": [
      [
        -9.35,
        "-",
        "LMT",
        -2486678340000
      ],
      [
        -9.35,
        "-",
        "PMT",
        -1855958340000
      ],
      [
        0,
        "France",
        "WE%sT",
        -932432400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -800064000000
      ],
      [
        0,
        "France",
        "WE%sT",
        -766616400000
      ],
      [
        -60,
        "France",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Berlin": [
      [
        -53.46666666666666,
        "-",
        "LMT",
        -2422051200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -776556000000
      ],
      [
        -60,
        "SovietZone",
        "CE%sT",
        -725932800000
      ],
      [
        -60,
        "Germany",
        "CE%sT",
        347068800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Busingen": "Europe/Zurich",
    "Europe/Gibraltar": [
      [
        21.4,
        "-",
        "LMT",
        -2821651200000
      ],
      [
        0,
        "GB-Eire",
        "%s",
        -401320800000
      ],
      [
        -60,
        "-",
        "CET",
        410140800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Athens": [
      [
        -94.86666666666667,
        "-",
        "LMT",
        -2344636800000
      ],
      [
        -94.86666666666667,
        "-",
        "AMT",
        -1686095940000
      ],
      [
        -120,
        "Greece",
        "EE%sT",
        -904867200000
      ],
      [
        -60,
        "Greece",
        "CE%sT",
        -812419200000
      ],
      [
        -120,
        "Greece",
        "EE%sT",
        378604800000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Budapest": [
      [
        -76.33333333333333,
        "-",
        "LMT",
        -2500934400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -1609545600000
      ],
      [
        -60,
        "Hungary",
        "CE%sT",
        -906768000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -757468800000
      ],
      [
        -60,
        "Hungary",
        "CE%sT",
        338954400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Rome": [
      [
        -49.93333333333334,
        "-",
        "LMT",
        -3259094400000
      ],
      [
        -49.93333333333334,
        "-",
        "RMT",
        -2403562204000
      ],
      [
        -60,
        "Italy",
        "CE%sT",
        -830304000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -807148800000
      ],
      [
        -60,
        "Italy",
        "CE%sT",
        347068800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Vatican": "Europe/Rome",
    "Europe/San_Marino": "Europe/Rome",
    "Europe/Riga": [
      [
        -96.56666666666668,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -96.56666666666668,
        "-",
        "RMT",
        -1632002400000
      ],
      [
        -96.56666666666668,
        "1:00",
        "LST",
        -1618693200000
      ],
      [
        -96.56666666666668,
        "-",
        "RMT",
        -1601676000000
      ],
      [
        -96.56666666666668,
        "1:00",
        "LST",
        -1597266000000
      ],
      [
        -96.56666666666668,
        "-",
        "RMT",
        -1377302400000
      ],
      [
        -120,
        "-",
        "EET",
        -928022400000
      ],
      [
        -180,
        "-",
        "MSK",
        -899510400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -795830400000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        604720800000
      ],
      [
        -120,
        "1:00",
        "EEST",
        620618400000
      ],
      [
        -120,
        "Latvia",
        "EE%sT",
        853804800000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        951782400000
      ],
      [
        -120,
        "-",
        "EET",
        978393600000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Vaduz": "Europe/Zurich",
    "Europe/Vilnius": [
      [
        -101.26666666666667,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -84,
        "-",
        "WMT",
        -1641081600000
      ],
      [
        -95.6,
        "-",
        "KMT",
        -1585094400000
      ],
      [
        -60,
        "-",
        "CET",
        -1561248000000
      ],
      [
        -120,
        "-",
        "EET",
        -1553558400000
      ],
      [
        -60,
        "-",
        "CET",
        -928195200000
      ],
      [
        -180,
        "-",
        "MSK",
        -900115200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -802137600000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        606880800000
      ],
      [
        -120,
        "Russia",
        "EE%sT",
        686109600000
      ],
      [
        -120,
        "C-Eur",
        "EE%sT",
        915062400000
      ],
      [
        -120,
        "-",
        "EET",
        891133200000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        941331600000
      ],
      [
        -120,
        "-",
        "EET",
        1041379200000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Luxembourg": [
      [
        -24.6,
        "-",
        "LMT",
        -2069712000000
      ],
      [
        -60,
        "Lux",
        "CE%sT",
        -1612656000000
      ],
      [
        0,
        "Lux",
        "WE%sT",
        -1269813600000
      ],
      [
        0,
        "Belgium",
        "WE%sT",
        -935182800000
      ],
      [
        -60,
        "C-Eur",
        "WE%sT",
        -797979600000
      ],
      [
        -60,
        "Belgium",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Malta": [
      [
        -58.06666666666666,
        "-",
        "LMT",
        -2403475200000
      ],
      [
        -60,
        "Italy",
        "CE%sT",
        102384000000
      ],
      [
        -60,
        "Malta",
        "CE%sT",
        378604800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Chisinau": [
      [
        -115.33333333333333,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -115,
        "-",
        "CMT",
        -1637107200000
      ],
      [
        -104.4,
        "-",
        "BMT",
        -1213142400000
      ],
      [
        -120,
        "Romania",
        "EE%sT",
        -927158400000
      ],
      [
        -120,
        "1:00",
        "EEST",
        -898128000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -800150400000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        641959200000
      ],
      [
        -120,
        "Russia",
        "EE%sT",
        725760000000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        883526400000
      ],
      [
        -120,
        "Moldova",
        "EE%sT",
        null
      ]
    ],
    "Europe/Monaco": [
      [
        -29.53333333333333,
        "-",
        "LMT",
        -2486678400000
      ],
      [
        -9.35,
        "-",
        "PMT",
        -1855958400000
      ],
      [
        0,
        "France",
        "WE%sT",
        -766616400000
      ],
      [
        -60,
        "France",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Amsterdam": [
      [
        -19.53333333333333,
        "-",
        "LMT",
        -4228761600000
      ],
      [
        -19.53333333333333,
        "Neth",
        "%s",
        -1025740800000
      ],
      [
        -20,
        "Neth",
        "+0020/+0120",
        -935020800000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -781048800000
      ],
      [
        -60,
        "Neth",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Oslo": [
      [
        -43,
        "-",
        "LMT",
        -2366755200000
      ],
      [
        -60,
        "Norway",
        "CE%sT",
        -927507600000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -781048800000
      ],
      [
        -60,
        "Norway",
        "CE%sT",
        347068800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Warsaw": [
      [
        -84,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -84,
        "-",
        "WMT",
        -1717027200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -1618693200000
      ],
      [
        -120,
        "Poland",
        "EE%sT",
        -1501718400000
      ],
      [
        -60,
        "Poland",
        "CE%sT",
        -931730400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -796867200000
      ],
      [
        -60,
        "Poland",
        "CE%sT",
        252374400000
      ],
      [
        -60,
        "W-Eur",
        "CE%sT",
        599529600000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Lisbon": [
      [
        36.75,
        "-",
        "LMT",
        -2682374400000
      ],
      [
        36.75,
        "-",
        "LMT",
        -1830384000000
      ],
      [
        0,
        "Port",
        "WE%sT",
        -118274400000
      ],
      [
        -60,
        "-",
        "CET",
        212547600000
      ],
      [
        0,
        "Port",
        "WE%sT",
        433299600000
      ],
      [
        0,
        "W-Eur",
        "WE%sT",
        717555600000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        828234000000
      ],
      [
        0,
        "EU",
        "WE%sT",
        null
      ]
    ],
    "Europe/Bucharest": [
      [
        -104.4,
        "-",
        "LMT",
        -2469398400000
      ],
      [
        -104.4,
        "-",
        "BMT",
        -1213142400000
      ],
      [
        -120,
        "Romania",
        "EE%sT",
        354679200000
      ],
      [
        -120,
        "C-Eur",
        "EE%sT",
        694137600000
      ],
      [
        -120,
        "Romania",
        "EE%sT",
        788832000000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        883526400000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Kaliningrad": [
      [
        -82,
        "-",
        "LMT",
        -2422051200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -757468800000
      ],
      [
        -120,
        "Poland",
        "CE%sT",
        -725932800000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        606880800000
      ],
      [
        -120,
        "Russia",
        "EE%sT",
        1301191200000
      ],
      [
        -180,
        "-",
        "+03",
        1414288800000
      ],
      [
        -120,
        "-",
        "EET",
        null
      ]
    ],
    "Europe/Moscow": [
      [
        -150.28333333333333,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -150.28333333333333,
        "-",
        "MMT",
        -1688256000000
      ],
      [
        -151.31666666666666,
        "Russia",
        "%s",
        -1593820800000
      ],
      [
        -180,
        "Russia",
        "%s",
        -1522713600000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        -1491177600000
      ],
      [
        -120,
        "-",
        "EET",
        -1247529600000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        670384800000
      ],
      [
        -120,
        "Russia",
        "EE%sT",
        695786400000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        1301191200000
      ],
      [
        -240,
        "-",
        "MSK",
        1414288800000
      ],
      [
        -180,
        "-",
        "MSK",
        null
      ]
    ],
    "Europe/Simferopol": [
      [
        -136.4,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -136,
        "-",
        "SMT",
        -1441152000000
      ],
      [
        -120,
        "-",
        "EET",
        -1247529600000
      ],
      [
        -180,
        "-",
        "MSK",
        -888883200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -811641600000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        662601600000
      ],
      [
        -180,
        "-",
        "MSK",
        646797600000
      ],
      [
        -120,
        "-",
        "EET",
        725760000000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        767750400000
      ],
      [
        -180,
        "E-Eur",
        "MSK/MSD",
        828230400000
      ],
      [
        -180,
        "1:00",
        "MSD",
        846385200000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        883526400000
      ],
      [
        -180,
        "-",
        "MSK",
        857178000000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        1396144800000
      ],
      [
        -240,
        "-",
        "MSK",
        1414288800000
      ],
      [
        -180,
        "-",
        "MSK",
        null
      ]
    ],
    "Europe/Astrakhan": [
      [
        -192.2,
        "-",
        "LMT",
        -1441238400000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        606880800000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -240,
        "-",
        "+04",
        701834400000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        1414288800000
      ],
      [
        -180,
        "-",
        "+03",
        1459044000000
      ],
      [
        -240,
        "-",
        "+04",
        null
      ]
    ],
    "Europe/Volgograd": [
      [
        -177.66666666666666,
        "-",
        "LMT",
        -1577750400000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "-",
        "+04",
        -256867200000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        575431200000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -240,
        "-",
        "+04",
        701834400000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        1414288800000
      ],
      [
        -180,
        "-",
        "+03",
        1540692000000
      ],
      [
        -240,
        "-",
        "+04",
        null
      ]
    ],
    "Europe/Saratov": [
      [
        -184.3,
        "-",
        "LMT",
        -1593820800000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        575431200000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -240,
        "-",
        "+04",
        701834400000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        1414288800000
      ],
      [
        -180,
        "-",
        "+03",
        1480816800000
      ],
      [
        -240,
        "-",
        "+04",
        null
      ]
    ],
    "Europe/Kirov": [
      [
        -198.8,
        "-",
        "LMT",
        -1593820800000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        606880800000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -240,
        "-",
        "+04",
        701834400000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        1414288800000
      ],
      [
        -180,
        "-",
        "+03",
        null
      ]
    ],
    "Europe/Samara": [
      [
        -200.33333333333334,
        "-",
        "LMT",
        -1593820800000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "-",
        "+04",
        -1102291200000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        606880800000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -120,
        "Russia",
        "+02/+03",
        686109600000
      ],
      [
        -180,
        "-",
        "+03",
        687927600000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        1269741600000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        null
      ]
    ],
    "Europe/Ulyanovsk": [
      [
        -193.6,
        "-",
        "LMT",
        -1593820800000
      ],
      [
        -180,
        "-",
        "+03",
        -1247529600000
      ],
      [
        -240,
        "Russia",
        "+04/+05",
        606880800000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        670384800000
      ],
      [
        -120,
        "Russia",
        "+02/+03",
        695786400000
      ],
      [
        -180,
        "Russia",
        "+03/+04",
        1301191200000
      ],
      [
        -240,
        "-",
        "+04",
        1414288800000
      ],
      [
        -180,
        "-",
        "+03",
        1459044000000
      ],
      [
        -240,
        "-",
        "+04",
        null
      ]
    ],
    "Europe/Belgrade": [
      [
        -82,
        "-",
        "LMT",
        -2682374400000
      ],
      [
        -60,
        "-",
        "CET",
        -905821200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -757468800000
      ],
      [
        -60,
        "-",
        "CET",
        -777938400000
      ],
      [
        -60,
        "1:00",
        "CEST",
        -766620000000
      ],
      [
        -60,
        "-",
        "CET",
        407203200000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Ljubljana": "Europe/Belgrade",
    "Europe/Podgorica": "Europe/Belgrade",
    "Europe/Sarajevo": "Europe/Belgrade",
    "Europe/Skopje": "Europe/Belgrade",
    "Europe/Zagreb": "Europe/Belgrade",
    "Europe/Bratislava": "Europe/Prague",
    "Europe/Madrid": [
      [
        14.733333333333334,
        "-",
        "LMT",
        -2177453684000
      ],
      [
        0,
        "Spain",
        "WE%sT",
        -940208400000
      ],
      [
        -60,
        "Spain",
        "CE%sT",
        315446400000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Stockholm": [
      [
        -72.2,
        "-",
        "LMT",
        -2871676800000
      ],
      [
        -60.233333333333334,
        "-",
        "SET",
        -2208988800000
      ],
      [
        -60,
        "-",
        "CET",
        -1692493200000
      ],
      [
        -60,
        "1:00",
        "CEST",
        -1680476400000
      ],
      [
        -60,
        "-",
        "CET",
        347068800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Zurich": [
      [
        -34.13333333333333,
        "-",
        "LMT",
        -3675196800000
      ],
      [
        -29.76666666666667,
        "-",
        "BMT",
        -2385244800000
      ],
      [
        -60,
        "Swiss",
        "CE%sT",
        378604800000
      ],
      [
        -60,
        "EU",
        "CE%sT",
        null
      ]
    ],
    "Europe/Istanbul": [
      [
        -115.86666666666667,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -116.93333333333332,
        "-",
        "IMT",
        -1869868800000
      ],
      [
        -120,
        "Turkey",
        "EE%sT",
        277257600000
      ],
      [
        -180,
        "Turkey",
        "+03/+04",
        482803200000
      ],
      [
        -120,
        "Turkey",
        "EE%sT",
        1199059200000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        1301187600000
      ],
      [
        -120,
        "-",
        "EET",
        1301274000000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        1396141200000
      ],
      [
        -120,
        "-",
        "EET",
        1396227600000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        1445734800000
      ],
      [
        -120,
        "1:00",
        "EEST",
        1446944400000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        1473206400000
      ],
      [
        -180,
        "-",
        "+03",
        null
      ]
    ],
    "Europe/Kiev": [
      [
        -122.06666666666668,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -122.06666666666668,
        "-",
        "KMT",
        -1441152000000
      ],
      [
        -120,
        "-",
        "EET",
        -1247529600000
      ],
      [
        -180,
        "-",
        "MSK",
        -892512000000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -825379200000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        646797600000
      ],
      [
        -120,
        "1:00",
        "EEST",
        686113200000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        820368000000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Uzhgorod": [
      [
        -89.2,
        "-",
        "LMT",
        -2500934400000
      ],
      [
        -60,
        "-",
        "CET",
        -915235200000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -796867200000
      ],
      [
        -60,
        "1:00",
        "CEST",
        -794707200000
      ],
      [
        -60,
        "-",
        "CET",
        -773452800000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        662601600000
      ],
      [
        -180,
        "-",
        "MSK",
        646797600000
      ],
      [
        -60,
        "-",
        "CET",
        670388400000
      ],
      [
        -120,
        "-",
        "EET",
        725760000000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        820368000000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ],
    "Europe/Zaporozhye": [
      [
        -140.66666666666666,
        "-",
        "LMT",
        -2808604800000
      ],
      [
        -140,
        "-",
        "+0220",
        -1441152000000
      ],
      [
        -120,
        "-",
        "EET",
        -1247529600000
      ],
      [
        -180,
        "-",
        "MSK",
        -894758400000
      ],
      [
        -60,
        "C-Eur",
        "CE%sT",
        -826416000000
      ],
      [
        -180,
        "Russia",
        "MSK/MSD",
        670384800000
      ],
      [
        -120,
        "E-Eur",
        "EE%sT",
        820368000000
      ],
      [
        -120,
        "EU",
        "EE%sT",
        null
      ]
    ]
  }
});